import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import {
  SuccessContainer,
  IllustrationWrapper,
  Illustration,
} from './ReadyToStart.styles';

import AppDownloadLinks from '../../components/AppDownloadLinks/AppDownloadLinks';

import DaylightIllustration from '@/assets/Party_Confetti.svg';
import { getPlatform } from '@/pages/Onboarding/utils/platformHelpers';
import { Platform, Product } from '@/utils/productHelpers';

type Props = {
  product: Product;
};

const PRODUCT_CONFIG: Record<string, {
  titleKey: string;
  subtitleKey: string;
  desktopSubtitleKey: string;
}> = {
  daylight: {
    titleKey: 'coverage.spring_health.ready_to_start.title',
    subtitleKey: 'coverage.spring_health.ready_to_start.subtitle',
    desktopSubtitleKey: 'coverage.spring_health.ready_to_start.subtitle_desktop',
  },
  sleepio: {
    titleKey: 'coverage.spring_health.ready_to_start.title_sleepio',
    subtitleKey: 'coverage.spring_health.ready_to_start.subtitle_sleepio',
    desktopSubtitleKey: 'coverage.spring_health.ready_to_start.subtitle_sleepio_desktop',
  },
};

const ReadyToStart: React.FC<Props> = ({ product }) => {
  const { t } = useTranslation();
  const platform = getPlatform();

  const config = PRODUCT_CONFIG[product] ?? PRODUCT_CONFIG.sleepio;

  const subtitleKey = platform === Platform.Web
    ? config.desktopSubtitleKey
    : config.subtitleKey;

  return (
    <SuccessContainer>
      <IllustrationWrapper>
        <Illustration src={DaylightIllustration} alt="Success" />
      </IllustrationWrapper>
      <Typography variant="h2" style={{ marginBottom: 8 }}>
        {t(config.titleKey)}
      </Typography>
      <Typography style={{ marginBottom: 16 }}>
        {t(subtitleKey)}
      </Typography>
      <AppDownloadLinks product={product} />
    </SuccessContainer>
  );
};

export default ReadyToStart;
